var t = [], a = 0, n = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new WeakMap(), l = (e, r) => {
  t.push(e);
  try {
    return r();
  } finally {
    t.pop();
  }
}, c = () => t[t.length - 1], d = (e) => {
  t.push(void 0);
  try {
    return e();
  } finally {
    t.pop();
  }
}, u = (e) => {
  if (a > 0) {
    n.add(e);
    return;
  }
  e();
}, o = () => {
  for (const e of Array.from(n)) {
    n.delete(e);
    try {
      e();
    } catch (r) {
      console.error("bQuery reactive: Error in observer during batch flush", r);
    }
  }
}, f = () => {
  a += 1;
}, p = () => {
  a <= 0 || (a -= 1, a === 0 && o());
}, v = (e, r) => {
  let s = i.get(e);
  s || (s = /* @__PURE__ */ new Set(), i.set(e, s)), s.add(r);
}, b = (e, r) => {
  const s = i.get(e);
  s && s.delete(r);
}, g = (e) => {
  const r = i.get(e);
  if (r) {
    for (const s of r) s.unsubscribe(e);
    r.clear();
  }
}, h = class {
  constructor(e) {
    this._value = e, this.subscribers = /* @__PURE__ */ new Set();
  }
  get value() {
    const e = c();
    return e && (this.subscribers.add(e), v(e, this)), this._value;
  }
  set value(e) {
    if (Object.is(this._value, e)) return;
    this._value = e;
    const r = Array.from(this.subscribers);
    for (const s of r) u(s);
  }
  peek() {
    return this._value;
  }
  update(e) {
    this.value = e(this._value);
  }
  dispose() {
    for (const e of this.subscribers) b(e, this);
    this.subscribers.clear();
  }
  unsubscribe(e) {
    this.subscribers.delete(e);
  }
}, y = (e) => new h(e);
export {
  p as a,
  u as c,
  g as i,
  l,
  y as n,
  c as o,
  f as r,
  v as s,
  h as t,
  d as u
};

//# sourceMappingURL=core-CongXJuo.js.map